var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourtType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.208496 0.0416718H1.41683H25.5835H26.7918V1.25001V15.75V16.9583H25.5835H1.41683H0.208496V15.75V1.25001V0.0416718ZM2.62516 1.25001H1.41683V2.45834V14.5417V15.75H2.62516H12.896V13.3333H1.41683V12.125H7.4585V4.87501H1.41683V3.66667H12.896V1.25001H2.62516ZM14.1043 1.25001V3.66667H25.5835L25.5835 2.45834V1.25001H24.3752H14.1043ZM12.896 4.87501H8.66683V7.89584H12.896V4.87501ZM14.1043 7.89584V4.87501H18.3335L18.3335 7.89584H14.1043ZM12.896 9.10417H8.66683V12.125H12.896V9.10417ZM14.1043 12.125V9.10417H18.3335L18.3335 12.125H14.1043ZM14.1043 13.3333V15.75H24.3752H25.5835V14.5417L25.5835 13.3333H14.1043ZM19.5418 4.87501V12.125H25.5835V4.87501H19.5418Z",
    fill: "#059669"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourtType);
export default __webpack_public_path__ + "static/media/courtType.c671dc87.svg";
export { ForwardRef as ReactComponent };